// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YRPjjGQ2SNCAaJE9yztI {
  padding: 1.2vmin;
  background-color: var(--tan-1);
  border: 0.1vmin solid var(--tan-3);
  border-radius: 2vmin;
  width: 40vmin;
  height: 80vh;
  margin: 0;
  margin-top: -1vmin;
  overflow: scroll;
  display: flex;
  box-shadow: 0, 0, 0.1vmin rgba(0, 0, 128, 0.5);
}

.IkD0xjvp68XbyGxaGLNa {
  font-size: 4vmin;
  font-weight: 500;
  font-variant: small-caps;
  margin-top: -0.4vmin;
  margin-bottom: -0.4vmin;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/CoinPriceList/CoinPriceList.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,8CAAA;AACJ;;AAEA;EACI,gBAAA;EACA,gBAAA;EACA,wBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;AACJ","sourcesContent":[".CoinPriceList {\n    padding: 1.2vmin;\n    background-color: var(--tan-1);\n    border: .1vmin solid var(--tan-3);\n    border-radius: 2vmin;\n    width: 40vmin;\n    height: 80vh;\n    margin: 0;\n    margin-top: -1vmin;\n    overflow: scroll;\n    display: flex;\n    box-shadow: 0, 0, .1vmin rgba(0, 0, 128, 0.5);\n}\n\n.title {\n    font-size: 4vmin;\n    font-weight: 500;\n    font-variant: small-caps;\n    margin-top: -0.4vmin;\n    margin-bottom: -0.4vmin;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CoinPriceList": `YRPjjGQ2SNCAaJE9yztI`,
	"title": `IkD0xjvp68XbyGxaGLNa`
};
export default ___CSS_LOADER_EXPORT___;
